import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';
// import '../letterstyles/JoiningLetter.css';

const AgreementLetter = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const printRef = useRef();

  const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

 const handlePrint = useReactToPrint({
     contentRef: printRef,
     documentTitle: 'Joining_Letter',
  });

 const handleDownloadPDF = () => {
  const element = printRef.current;

  const opt = {
    margin: [5, 5, 5, 5],          // Perfect padding so content doesn't cut
    filename: "Offer_Letter.pdf",
    image: { type: "jpeg", quality: 0.98 },

    html2canvas: {
      scale: 3,                   // HD rendering (fixes blurry text)
      useCORS: true,              // allows cross-origin images
      allowTaint: true,           // helps load local images
      logging: false,
      dpi: 300,
      letterRendering: true,
    },

    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
      compressPdf: true,
    },
  };

   html2pdf().set(opt).from(element).save();
  };

  // Fetch company details from same API as ManageCompanyDetails
  useEffect(() => {
    if (!state?.user) {
      alert("No user data provided");
      navigate('/');
    }

    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          // Dynamically construct logo URL
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, '')}`;
          }
          setCompany(data);
        } else {
          console.error('Failed to fetch company data');
        }
      } catch (err) {
        console.error('Error fetching company details:', err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [navigate, state?.user, superAdminId]);

  const user = state?.user;
//   console.log(user);
  if (!user) return null;
  if (loading) return <p>Loading company details...</p>;

  return (
    <div className="letter-wrapper">
     

      <div className="joining-letter" ref={printRef}>
        <div className="letter-header">
          <img 
            src={company?.logoUrl || '/default-logo.png'} 
            alt="Company Logo" 
            className="letter-logo" 
          />
          <div className="letter-company-info">
            <h2>{company?.name}</h2>
            <p><strong>CIN:</strong> {company?.cin}</p>
            <p><strong>Email:</strong> {company?.email}</p>
            <p><strong>Regt. Office:</strong> {company?.address}</p>
          </div>
        </div>

        <div className="letter-body">
          <p style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold' }}><strong>Employee Agreement Letter</strong></p>
          <p style={{ textAlign: 'right' }}><strong>Date:</strong> {new Date().toLocaleDateString()}</p>
          <p>To,</p>
          <p><strong>{user.fullName}</strong></p>
          <p>{user.branch}</p>
          <p><strong>{user.address}</strong></p>
          <p><strong>{user.district}, {user.state}, {user.pincode}</strong></p>
          <p><strong>Subject: </strong> Service Agreement Letter </p>
          <p><strong>Dear Mr./Mrs. {user.fullName},</strong></p>

          
          <p>We are pleased to inform you that you are being appointed to the position of <strong>{user.roleName} </strong> at <strong>{company?.name}</strong>. Through this letter, we are sharing with you the terms and conditions of the service agreement:</p>
          <hr />
          <p><strong>1. Position and Location</strong></p>
          <p>You are being appointed as {user.roleName}, and your workplace will be {user.branchName}. As per the company’s requirements, you may be transferred to other branches as well.</p>
          <hr />
          <p><strong>2. Date of Commencement</strong></p>
          <p>Your appointment will be considered effective from {new Date().toLocaleDateString()}.</p>
          <hr />
          <p><strong>3. Salary and Allowances</strong></p>
          <p>You will be provided a monthly salary of ₹________(Rupees__________________). In addition, other allowances may be provided from time to time as per the company’s policies.</p>
          <hr />
          <p><strong>4. Working Hours</strong></p>
          <p>As per company rules, working hours will be from ____AM/PM to ___AM/PM. There will be ____ working days in a week.</p>
          <hr />
          <p><strong>5. Confidentiality</strong></p>
          <p>You shall keep all company-related information confidential and will not share it with any third party.</p>
          <hr />
          <p><strong>6. Termination of Service</strong></p>
          <p>If you wish to leave the company, you must provide at least <strong>30</strong> days prior notice or salary in lieu of that period. Similarly, the company will also provide notice before terminating your service.</p>
          <hr />
          <p><strong>7. Other Conditions</strong></p>
          <p>• You must comply with all company rules and codes of conduct.<br/>
          • Any kind of indiscipline may lead to termination of the contract.</p>

          <hr />
          <p>Please sign a copy of this letter to indicate your acceptance and return it to us.We wish you a bright future with our organization.</p>

          <p><strong>Sincerely,</strong></p>
          <p>Signature:</p>
          <p>Name:</p>
          <p>{user.roleName}</p>
          <p>{company.name}</p>
          <hr />
          <div className='no-break'>
            <p><strong> Acceptance</strong></p>
            <p>I, <strong>{user.fullName}</strong>, have read and agree to all the terms mentioned above and accept this appointment.</p>
            <p>Signature: ____________________</p>
            <p> Date:     ____________________</p>
          </div>
        </div>

        <div className="letter-footer">
          <hr />
          <p>{company?.name} | CIN: {company?.cin}</p>
          <p>Email: {company?.email} | Address: {company?.address}</p>
        </div>
      </div>


       <div className="letter-actions">
        <button onClick={handlePrint} className="letter-action-button">Print</button>
        <button onClick={handleDownloadPDF} className="letter-action-button">Download</button>
      </div>

      
    </div>
  );
};

export default AgreementLetter;
